
export default {
  productData: {
    serialNumber: 'DA-MME-011',
    name: 'Massivholzdecke mit Estrich l Aufbau 11',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte MW<br>(<i>s‘</i> ≤ 8 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 30',
          value: 'm-30'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB 100 gebundene Schüttung (<i>m‘</i> ≥ 157,9 kg/m<sup>2</sup>)' },
          output: '≥ 105',
          value: 'scsb100-105'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Brettsperrholzdecke' },
          output: 120,
          value: 'bsh-120'
        }
      ],
      sum: {
        output: '315', value: 315
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '45 (-3; 1)',
        value: 45
      },
      soundReductionIndex: { // Rw
        output: '77 (-2; -6)',
        value: 77
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,44',
        value: 0.44
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '368 [kg/m²]'
      }
    }
  },
  image: 'da-mme-011.svg',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-11-DA-MME-011-Rev01.pdf'
}
